import React, { useRef, useState } from 'react';
import { DefaultButton, Dialog, DialogType, DialogFooter, PrimaryButton, IconButton, Stack, Text, Icon, TooltipHost } from '@fluentui/react';
import { t } from 'i18next';

interface SelectFilesProps {
  files: File[];
  onMultipleFiles: (file: File[]) => void;
  onFileDelete: (index: number) => void;
  disabled: boolean;
}

export default function SelectFiles({ files, onMultipleFiles, onFileDelete, disabled }: SelectFilesProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleFileClick = () => {
    if (files.length > 0) {
      setIsDialogOpen(true);
    } else {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const selectedFiles = Array.from(e.target.files);
      onMultipleFiles(selectedFiles);
    }
    e.target.value = ''; // limpiar input para que se pueda seleccionar el mismo archivo de nuevo
  };

  return (
    <div>
      <input type="file" multiple hidden ref={fileInputRef} onChange={handleFileChange} disabled={disabled} />
      <TooltipHost content={files.length > 0 ? `${files.length} archivo(s) seleccionado(s)` : t('Seleccione un archivo')}>
        <Icon
          iconName="CloudUpload"
          style={{
            fontSize: '30px',
            cursor: disabled ? 'default' : 'pointer',
            color: files.length > 0 ? '#0078D4' : disabled ? '#9E9E9E' : 'black',
          }}
          className={files.length > 0 ? 'icon-clicked' : ''}
          onClick={handleFileClick}
        />
      </TooltipHost>

      <Dialog
        hidden={!isDialogOpen}
        onDismiss={() => setIsDialogOpen(false)}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: t("Documentos Adjuntos"),
          subText: files.length > 0 ? t('Tiene los siguientes documentos, puede eliminarlos o agregar más') : t('No hay documentos seleccionados'),
        }}
        minWidth={380}
        modalProps={{
          styles: { main: { maxWidth: 450, maxHeight: 800 } },
        }}
      >
        <Stack tokens={{ childrenGap: 10 }}>
          {files.map((file, index) => (
            <Stack horizontal horizontalAlign="space-between" key={index} verticalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { alignItems: 'center' } }}>
              <Stack horizontal key={index} verticalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { alignItems: 'center' } }}>
                <Icon iconName="CloudUpload" styles={{ root: { fontSize: 18, color: '#0078D4' } }} />
                <Text style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>{file.name}</Text>
              </Stack>
              <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" onClick={() => onFileDelete(index)} disabled={disabled} />
            </Stack>
          ))}
        </Stack>

        <DialogFooter>
          <PrimaryButton text={t("Explorar")} iconProps={{ iconName: 'OpenFile' }} onClick={() => fileInputRef.current?.click()} disabled={disabled} />
          <DefaultButton text={t("Cerrar")} onClick={() => setIsDialogOpen(false)} />
        </DialogFooter>
      </Dialog>
    </div>
  );
}
